import React, { useEffect, useRef, useState } from "react";
import { getMemberhipPlanCount, getMemberhipPlans } from "../helper/api";
import {isAuthenticated} from '../../../auth/index'
import { startLoader, stopLoader } from "../../../lib/utils";

const PersonalTrainingFilter = (props) => {

  const DummyPTPlans = ["Personal Training (Black Belt I)", "Personal Training (Black Belt )", "Personal Training (White Belt)", "Personal Training (White Belt)","Personal Training (White Belt)","Personal Training (White Belt)","Personal Training (White Belt)"];

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);

  const {user, token} = isAuthenticated();
  const pageNo = useRef({
    membershipPlan:1
  });
  const pageCount = useRef({
    membershipPlan:1
  });
  const total = useRef({
    membershipPlan:1
  });
  const pageSize = {
    membershipPlan:20
  };



  const [currentElementId, setCurrentElementId] = useState("");
  const [PTPlans, setPTPlans] = useState([]);

  const [isPTPackageDropdownOpen, setPTPackageDropdownOpen] = useState(false);
  const [selectedPT, setSelectedPT] = useState(false);
  const [totalSessions, setTotalSessions] = useState("");
  const [completedSessions, setCompletedSessions] = useState("");

  const GetMembershupPlanParams = () =>{
    const params = {
      pageNo:pageNo.current.membershipPlan,
      pageSize:pageSize.membershipPlan
    };

    params.type="PersonalTraining"

    return params;
  }

  const GetMembershupPlans = async () =>{
    try{
      const params = GetMembershupPlanParams();
      const response = await getMemberhipPlans(user,token,params);
      if(response.error){

      }else{
        setPTPlans(response);
      }

    }catch(error){

    }
  }

  const GetMembershupPlanCount = async () =>{
    try{
      const params = GetMembershupPlanParams();
      const response = await getMemberhipPlanCount(user,token,params);
      if(response.error){

      }else{
        const COUNT = response.COUNT;

        pageCount.current={
          ...pageCount.current,
          membershipPlan:Math.ceil(COUNT / pageSize.membershipPlan)
        };
        total.current={
          ...total.current,
          membershipPlan:COUNT
        };

        pageNo.current={
          ...pageNo.current,
          membershipPlan:1
        };
      }

    }catch(error){

    }
  }

  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
      if(id == "pt-sessions"){
        inputRef1.current.focus();
      }
      if(id == "completed-sessions"){
        inputRef2.current.focus();
      }
    }
  };

  const selectPT = (role) => {
    setSelectedPT(role)
  } 

  const handleChange = (name, value) => event => {
    value = !value ? event.target.value : value;
    if(name == 'pt-sessions'){
      setTotalSessions(value)
    }
    if(name == 'completed-sessions'){
      setCompletedSessions(value)
    }
  }

  useEffect(async () => {
    if(props.gymId && props.branchId){
      try{
        await startLoader();
        await GetMembershupPlanCount();
        await GetMembershupPlans();
        await stopLoader();
      }catch(error){
        await stopLoader(); 
      }
    }
  },[props])

  return(
    <div className="w-full">
      {
        props.headerView && (
          <p className="fs-16 m-t-8 m-b-6 font-weight-700 color-black">Personal Training Filter</p>
        )
      }
      <div onClick={()=>toggleInputFields('pt-package')} className={`${currentElementId == "pt-package" || selectedPT ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "pt-package" || selectedPT) ? "1px solid var(--darkBlue)" : "" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "pt-package" || selectedPT) ? "4px" : ""}}>
          <svg className="flex-item m-r-4" width={(currentElementId == "pt-package" || selectedPT) ? "14" : "24"} height={(currentElementId == "pt-package" || selectedPT) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.4375 20.6635V12.3223L4.125 8.09501V16.0465C4.125 16.1626 4.15388 16.2711 4.21163 16.3722C4.26938 16.4733 4.35563 16.5594 4.47038 16.6305L11.4375 20.6635ZM12.5625 20.6635L19.5285 16.6305C19.644 16.5586 19.7306 16.4725 19.7884 16.3722C19.8461 16.2711 19.875 16.1626 19.875 16.0465V8.09501L12.5625 12.3223V20.6635ZM11.091 21.7563L3.909 17.6233C3.624 17.4608 3.40163 17.24 3.24188 16.9607C3.08063 16.6814 3 16.3793 3 16.0544V7.94677C3 7.62107 3.08063 7.31858 3.24188 7.03931C3.40238 6.76003 3.62475 6.53916 3.909 6.37669L11.091 2.24371C11.376 2.08124 11.679 2 12 2C12.321 2 12.624 2.08124 12.909 2.24371L20.091 6.37669C20.376 6.53841 20.5987 6.75929 20.7592 7.03931C20.9197 7.31858 21 7.62107 21 7.94677V16.0544C21 16.3793 20.9197 16.6814 20.7592 16.9607C20.598 17.24 20.3752 17.4608 20.091 17.6233L12.909 21.7563C12.624 21.9188 12.321 22 12 22C11.679 22 11.376 21.9188 11.091 21.7563ZM16.176 8.93958L19.2281 7.18643L12.3465 3.20957C12.231 3.13769 12.1155 3.10175 12 3.10175C11.8845 3.10175 11.769 3.13769 11.6535 3.20957L8.9625 4.75382L16.176 8.93958ZM12 11.3565L15.0375 9.59546L7.80937 5.42543L4.77187 7.18531L12 11.3565Z" fill={(currentElementId == "pt-package" || selectedPT) ? "var(--darkBlue)" : "#6d6d6d"}/>
          </svg>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "pt-package" || selectedPT) ? "10px" : "16px", lineHeight: (currentElementId == "pt-package" || selectedPT) ? "10px" : "14px", color: (currentElementId == "pt-package" || selectedPT) ? "var(--darkBlue)" : "", transition: "180ms" }}>Package</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "pt-package" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        <input id="pt-package" className={`${(currentElementId == "pt-package" || selectedPT) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select PT Package" value={selectedPT ? selectedPT : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        {
          currentElementId == "pt-package" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
              <div onClick={e => e.stopPropagation()} className="w-full" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0}}>
                <div className="search-container d-flex space-between" style={{width:"100%",background:"#ffffff"}}>
                  <div className="d-flex w-full">
                    <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <input type="text" placeholder={`Search Personal Training by “Name“`} className="flex-item search-input" style={{width:"85%"}} />
                  </div>
                </div>
              </div>
              <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                {
                  PTPlans.map((plan, index) => {
                    return (
                      <div onClick={()=>selectPT(plan)} className="global-input-field-arrow-dropdown-item">
                        <p className="flex-item">{plan}</p>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
        }
      </div>
      <div className="d-flex w-full space-between">
    
        {
          props.totalSession && (
            <div onClick={()=>toggleInputFields('pt-sessions')} className={`${currentElementId == "pt-sessions" || totalSessions ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "pt-sessions" || totalSessions) ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
              <div className="flex-item d-flex" style={{marginTop: (currentElementId == "pt-sessions" || totalSessions) ? "8px" : ""}}>
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "pt-sessions" || totalSessions) ? "10px" : "16px", lineHeight: (currentElementId == "pt-sessions" || totalSessions) ? "10px" : "14px", color: (currentElementId == "pt-sessions" || totalSessions) ? "var(--darkBlue)" : "", transition: "180ms" }}>Total Sessions</p>
              </div>
              <input ref={inputRef1} onChange={handleChange('pt-sessions')} className={`${(currentElementId == "pt-sessions" || totalSessions) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder="Enter value" value={totalSessions ? totalSessions : ""} />
            </div>
          )
        }

        {
          props.completedSession && (
            <div onClick={()=>toggleInputFields('completed-sessions')} className={`${currentElementId == "completed-sessions" || completedSessions ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "completed-sessions" || completedSessions) ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
              <div className="flex-item d-flex" style={{marginTop: (currentElementId == "completed-sessions" || completedSessions) ? "8px" : ""}}>
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "completed-sessions" || completedSessions) ? "10px" : "16px", lineHeight: (currentElementId == "completed-sessions" || completedSessions) ? "10px" : "14px", color: (currentElementId == "completed-sessions" || completedSessions) ? "var(--darkBlue)" : "", transition: "180ms" }}>Completed Sessions</p>
              </div>
              <input ref={inputRef2} onChange={handleChange('completed-sessions')} className={`${(currentElementId == "completed-sessions" || completedSessions) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder="Enter value" value={completedSessions ? completedSessions : ""} />
            </div>
          )
        }
      </div>
    </div>
  )
}

export default PersonalTrainingFilter;